import React from 'react';
import { Button } from 'antd';
import {
    WarningFilled,
    ArrowRightOutlined,
    SafetyCertificateOutlined
} from '@ant-design/icons';
import './style.scss';

const CompleteProfileBanner = ({ onOpenModal }) => {
    return (
        <div className="complete-profile-banner">
            <div className="banner-left">
                <div className="banner-icon-badge">
                    <WarningFilled className="banner-icon" />
                </div>
                <div className="banner-text">
                    <span className="banner-title">
                        Complete Your Profile:
                    </span>
                    <span className="banner-desc">
                        Please provide your company and workplace details to ensure full access to your course certifications and student benefits.
                    </span>
                </div>
            </div>
            <div className="banner-right">
                <Button
                    type="primary"
                    className="banner-action-btn"
                    onClick={onOpenModal}
                    icon={<SafetyCertificateOutlined />}
                >
                    Complete Profile Now <ArrowRightOutlined />
                </Button>
            </div>
        </div>
    );
};

export default CompleteProfileBanner;
